import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import GlobalFilterPanel, { FILTER_PERIOD_GROUP, FIELDS as GlobalFilterPanelFields } from '../../filter/GlobalFilterPanel';
import LanguageStringResolver from '../../fields/language/LanguageStringResolver';
import DataMiningCommonFilterPanel from '../DataMiningCommonFilterPanel';
import Logger, { LOG_LEVELS } from '../../../utils/log';
import moment from 'moment';

const log = new Logger('DATA_MINING_SII_LOG_FILTER_PANEL', LOG_LEVELS.DEBUG);

const DEFAULT_FILTER_SETTING = {
    fieldOptions: {},
    hideElements : {
                    month: true,
                    year: true,
                    countryCode: true,
                    returnType: true,
                    returnStatus: true,
                    companyId: true
                },
     filterPeriodGroup : FILTER_PERIOD_GROUP.DATE_RANGE,
     adaptPeriodOptions : {
        customDateRangeProvider: (selection) => {
            let customDateRange = {};
            let selectionEndDate = selection.endDate ? moment.utc(selection.endDate) : moment.utc(new Date());
            customDateRange.endDate = selectionEndDate;
            customDateRange.startDate = moment.utc(selectionEndDate).subtract('1', 'month');
            return customDateRange;
        }
    }
};

export class SiiLogFilterPanel extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selection: {
                reportType: 'SII log',
                startDate: '',
                endDate: '',
                sortAscending: false
            },
            filterSetting: DEFAULT_FILTER_SETTING
        };
        this.onReportChangeHandler = this.onReportChangeHandler.bind(this);
        this.onCheckboxChangeHandler = this.onCheckboxChangeHandler.bind(this);
        this.onSearchClickHandler = this.onSearchClickHandler.bind(this);
    }

    onReportChangeHandler(selection = {}) {
        log.debug('onReportChangeHandler reportType', selection.reportType);
        this.props.onReportTypeChange(selection);
    }

    onCheckboxChangeHandler(evt) {
        let selection = Object.assign({}, this.state.selection);
        selection.sortAscending = !evt.target.checked;
        this.setState({
            selection: selection
        });
    }

    onSearchClickHandler(selection) {
        log.debug('onSearchClickHandler(): state.selection: ', this.state.selection);
        log.debug('onSearchClickHandler(): selection: ', selection);
        let existingSelection = Object.assign({}, this.state.selection);
        existingSelection.startDate = selection.startDate;
        existingSelection.endDate = selection.endDate;
        this.props.onSearchClick(existingSelection);
    }

    render() {
        log.debug('render() - props: ', this.props);
        let selection = this.state.selection || {};
        const filterSetting = this.state.filterSetting || DEFAULT_FILTER_SETTING;

        return (
            <div>
                <s-box name="filter-panel">                   
                    <GlobalFilterPanel
                        {...filterSetting}
                        onSearchClick={this.onSearchClickHandler}>

                        <DataMiningCommonFilterPanel
                            reportType={this.state.selection.reportType}
                            onReportTypeChange={this.onReportChangeHandler}
                        />
                        <fieldset>
                            <legend><LanguageStringResolver string='dataMining_SIILog_SortByDate' /></legend>
                            <span className="clear"></span>
                            <input
                                data-test="input-sort-by-date"
                                type="checkbox"
                                onChange={this.onCheckboxChangeHandler}
                                name="siiLogSortByDate"
                                checked={!selection.sortAscending}
                            />
                            <label className="checkbox"><LanguageStringResolver string='dataMining_descending_check' /></label>
                        </fieldset>
                    </GlobalFilterPanel>
                    <div className="clear"></div>
                </s-box>
            </div>
        );
    }
}


SiiLogFilterPanel.defaultProps = {
    onReportTypeChange: () => { },
    onSearchClick: () => { }
}

function mapStateToProps(state) {
    return {
        languages: state.languages
    }
}

function mapDispatchersToProps(dispatch) {
    return {};
}

// Wrap the component to inject dispatch and state into it
export default connect(mapStateToProps, mapDispatchersToProps)(SiiLogFilterPanel);